import Icon from '../components/Icon.vue'

Icon.register({
  'dumpster-fire': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M418.7 104.1L418.9 103.9 404.5 31.9H304V159.9H364.8C381 140.6 399 121.7 418.7 104.1zM272 32H171.5L145.9 160H272V32zM461.3 104.1C479.5 120.4 496.8 137.8 512.4 155.6 518.1 150 523.8 144.5 529.7 139.3L551 120.3 572.3 139.3C573.4 140.2 574.4 141.4 575.4 142.4 575.3 141.6 575.6 140.9 575.4 140.1L551.4 44.1C549.7 37 543.3 32 536 32H437.1L449.4 93.5 461.3 104.1zM16 160H113.3L138.9 32H40C32.7 32 26.3 37 24.5 44.1L0.5 140.1C-2 150.2 5.6 160 16 160zM340.6 192H32L36 224H16C7.2 224 0 231.2 0 240V272C0 280.8 7.2 288 16 288H44L64 448V464C64 472.8 71.2 480 80 480H112C120.8 480 128 472.8 128 464V448H336.8C306.6 414.3 288 370.1 288 321.6 288 285.7 307.9 238.7 340.6 192zM551.1 163.2C536.2 176.5 522.8 190.4 510.9 204.4 491.4 178.6 467.3 152.4 439.9 128 369.7 190.7 319.9 272.3 319.9 321.6 319.9 409.1 391.5 480 479.9 480S639.9 409.1 639.9 321.6C640 285 602.9 209.4 551.1 163.2zM532.5 392.6C517.8 403.3 499.6 409.6 480 409.6 431 409.6 391.1 376.1 391.1 321.6 391.1 294.5 407.6 270.6 440.5 229.7 445.2 235.3 507.6 317.8 507.6 317.8L547.4 270.8C550.2 275.6 552.8 280.3 555.1 284.8 573.7 321.5 565.9 368.4 532.5 392.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dumpster-fire.js
// module id = v30N
// module chunks = 144